import { render } from "./SignaturePopup.vue?vue&type=template&id=62c35bdc&scoped=true"
import script from "./SignaturePopup.vue?vue&type=script&lang=js"
export * from "./SignaturePopup.vue?vue&type=script&lang=js"

import "./SignaturePopup.vue?vue&type=style&index=0&id=62c35bdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c35bdc"]])

export default __exports__